/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  SignUpRequest,
  Signup200
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Create a new user, organization, and membership, then send verification email.
 *
 * Does not authenticate — user must verify email then log in.
 * If the user cancels verification, POST /auth/cancel-verification cleans up.
 *
 * Domain auto-join: if the email's domain matches an existing active
 * organization with a verified domain (set by a previous institution
 * admin during onboarding), skip org creation and join the new user
 * as a ``member`` of that org instead.
 *
 * Under ``AUTH_PROVIDER=gcp`` this delegates to ``_signup_gcp`` so the account
 * is created in the same provider that login verifies against.
 * @summary Signup
 */
export const signup = (
    signUpRequest: SignUpRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<Signup200>(
      {url: `/auth/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signUpRequest, signal
    },
      options);
    }




export const getSignupMutationKey = () => ['signup'] as const;

export const getSignupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,SignupMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,SignupMutationVariables, TContext> => {

const mutationKey = getSignupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signup>>, SignupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  signup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupMutationResult = NonNullable<Awaited<ReturnType<typeof signup>>>
    export type SignupMutationBody = SignUpRequest
    export type SignupMutationError = HTTPValidationError
    export type SignupMutationVariables = {data: SignUpRequest}

    /**
 * @summary Signup
 */
export const useSignup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,SignupMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof signup>>,
        TError,
        SignupMutationVariables,
        TContext
      > => {
      return useMutation(getSignupMutationOptions(options));
    }
